// extracted by mini-css-extract-plugin
export default {"reactTable":"TeacherAssignments_reactTable__Ip08D"};